import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RADIUS } from '../radius/radius';
import {
  COLOR_TEXT_INVERSE,
  COLOR_TEXT_PRIMARY,
  COLOR_TEXT_SECONDARY,
} from '../colors/colors';

const ModalHeaderImage = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 48px;
    height: 48px;
  }
`;

const Title = styled.h2`
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  color: ${COLOR_TEXT_SECONDARY};
  margin: 16px 0;
`;

const ActionButton = styled.button`
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: ${RADIUS.SM};
  background-color: ${({ $bgColor }) => $bgColor};
  color: ${({ $textColor }) => $textColor};
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 16px;

  &:hover {
    opacity: 0.9;
  }
`;

const YouFailed = ({
  errorMessage,
  buttonText,
  onTryAgain,
  iconSrc,
  iconAlt = 'failed',
  buttonBackgroundColor = COLOR_TEXT_PRIMARY,
  buttonTextColor = COLOR_TEXT_INVERSE,
}) => {
  return (
    <>
      <ModalHeaderImage data-testid="modal-header-image">
        <img src={iconSrc} alt={iconAlt} />
      </ModalHeaderImage>

      <Title data-testid="failed-title">{errorMessage}</Title>

      <ActionButton
        onClick={onTryAgain}
        data-testid="try-again-button"
        $bgColor={buttonBackgroundColor}
        $textColor={buttonTextColor}
      >
        {buttonText}
      </ActionButton>
    </>
  );
};

YouFailed.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  onTryAgain: PropTypes.func.isRequired,
  iconSrc: PropTypes.string.isRequired,
  iconAlt: PropTypes.string,
  buttonBackgroundColor: PropTypes.string,
  buttonTextColor: PropTypes.string,
};

export { YouFailed };
